module.exports = __webpack_public_path__ + "public/Icons/lightTransaprent.gif?27984790";